<h1 class="h3 mb-2 text-gray-800">Realizar Pago</h1>

<div class="card shadow mb-4">
    <div class="card-header py-3">
        <h6 class="m-0 font-weight-bold text-primary">Pago Inicial Refinamiento</h6>
    </div>
    <div class="card-body">
        <p>Para iniciar la planificación del refinamiento es necesario realizar el pago de <b>la suma de
                <span class="precioBlock" [innerHTML]="precioRefinamiento"></span>.</b><br>
            <app-datos-cobro></app-datos-cobro>
        </p>
        <div class="row">
            <div class="col-6" *ngIf="refinamiento">
                <form name="form" (ngSubmit)="f.form.valid && enviarDatos()" #f="ngForm">
                    <div class="form-group">
                        <label>Enviar comprobante de pago</label>
                        <div *ngIf="urlComprobante"><img [src]="urlComprobante" height="200"></div>
                        <input type="file" accept=".jpg, .jpeg, .png" #fileuploadTop="ngModel" [(ngModel)]="comprobante"
                            name="comprobante" (change)="seleccionarComprobante($event)" class="form-control"
                            [ngClass]="{'is-invalid':  f.submitted && fileuploadTop.invalid}" required />
                        <div *ngIf="f.submitted && fileuploadTop.invalid" class="invalid-feedback">
                            <div *ngIf="fileuploadTop.errors.required">El comprobante es requerido</div>
                        </div>
                    </div>

                    <div class="form-group">
                        <button type="submit" class="btn btn-primary">Enviar para verificación</button>
                        <a [routerLink]="'/casos/'+refinamiento.caso_id+'/verpaciente'" class="btn btn-link">Volver</a>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>